 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_Cover'
 import EBB from '@/components/ebb'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import A5_TITLE from '@/components/05_Title'
 import XHTML100_COVER from '@/components/xhtml1/00_Cover'
 import XHTML104_PRAISE from '@/components/xhtml1/04_Praise'
 import XHTML105_TITLE from '@/components/xhtml1/05_Title'
 import XHTML106_DED from '@/components/xhtml1/06_Ded'
 import XHTML109_FM02 from '@/components/xhtml1/09_Fm02'
 import XHTML110_PART01 from '@/components/xhtml1/10_Part01'
 import XHTML111_CHAPTER1_01 from '@/components/xhtml1/11_Chapter1_01'
 import XHTML112_CHAPTER1_02 from '@/components/xhtml1/12_Chapter1_02'
 import XHTML113_CHAPTER1_03 from '@/components/xhtml1/13_Chapter1_03'
 import XHTML114_CHAPTER1_04 from '@/components/xhtml1/14_Chapter1_04'
 import XHTML115_CHAPTER1_05 from '@/components/xhtml1/15_Chapter1_05'
 import XHTML116_CHAPTER1_06 from '@/components/xhtml1/16_Chapter1_06'
 import XHTML117_CHAPTER1_07 from '@/components/xhtml1/17_Chapter1_07'
 import XHTML118_CHAPTER1_08 from '@/components/xhtml1/18_Chapter1_08'
 import XHTML119_CHAPTER1_09 from '@/components/xhtml1/19_Chapter1_09'
 import XHTML120_CHAPTER1_10 from '@/components/xhtml1/20_Chapter1_10'
 import XHTML121_CHAPTER1_11 from '@/components/xhtml1/21_Chapter1_11'
 import XHTML122_CHAPTER1_12 from '@/components/xhtml1/22_Chapter1_12'
 import XHTML123_CHAPTER1_13 from '@/components/xhtml1/23_Chapter1_13'
 import XHTML124_CHAPTER1_14 from '@/components/xhtml1/24_Chapter1_14'
 import XHTML125_CHAPTER1_15 from '@/components/xhtml1/25_Chapter1_15'
 import XHTML126_PART02 from '@/components/xhtml1/26_Part02'
 import XHTML127_CHAPTER2_01 from '@/components/xhtml1/27_Chapter2_01'
 import XHTML128_CHAPTER2_02 from '@/components/xhtml1/28_Chapter2_02'
 import XHTML129_CHAPTER2_03 from '@/components/xhtml1/29_Chapter2_03'
 import XHTML130_CHAPTER2_04 from '@/components/xhtml1/30_Chapter2_04'
 import XHTML131_CHAPTER2_05 from '@/components/xhtml1/31_Chapter2_05'
 import XHTML132_CHAPTER2_06 from '@/components/xhtml1/32_Chapter2_06'
 import XHTML133_CHAPTER2_07 from '@/components/xhtml1/33_Chapter2_07'
 import XHTML134_CHAPTER2_08 from '@/components/xhtml1/34_Chapter2_08'
 import XHTML135_CHAPTER2_09 from '@/components/xhtml1/35_Chapter2_09'
 import XHTML136_CHAPTER2_10 from '@/components/xhtml1/36_Chapter2_10'
 import XHTML137_CHAPTER2_11 from '@/components/xhtml1/37_Chapter2_11'
 import XHTML138_CHAPTER2_12 from '@/components/xhtml1/38_Chapter2_12'
 import XHTML139_CHAPTER2_13 from '@/components/xhtml1/39_Chapter2_13'
 import XHTML140_CHAPTER2_14 from '@/components/xhtml1/40_Chapter2_14'
 import XHTML141_CHAPTER2_15 from '@/components/xhtml1/41_Chapter2_15'
 import XHTML142_PART03 from '@/components/xhtml1/42_Part03'
 import XHTML143_CHAPTER3_01 from '@/components/xhtml1/43_Chapter3_01'
 import XHTML144_CHAPTER3_02 from '@/components/xhtml1/44_Chapter3_02'
 import XHTML145_CHAPTER3_03 from '@/components/xhtml1/45_Chapter3_03'
 import XHTML146_CHAPTER3_04 from '@/components/xhtml1/46_Chapter3_04'
 import XHTML147_CHAPTER3_05 from '@/components/xhtml1/47_Chapter3_05'
 import XHTML148_CHAPTER3_06 from '@/components/xhtml1/48_Chapter3_06'
 import XHTML149_CHAPTER3_07 from '@/components/xhtml1/49_Chapter3_07'
 import XHTML150_CHAPTER3_08 from '@/components/xhtml1/50_Chapter3_08'
 import XHTML151_CHAPTER3_09 from '@/components/xhtml1/51_Chapter3_09'
 import XHTML152_CHAPTER3_10 from '@/components/xhtml1/52_Chapter3_10'
 import XHTML153_CHAPTER3_11 from '@/components/xhtml1/53_Chapter3_11'
 import XHTML154_CHAPTER3_12 from '@/components/xhtml1/54_Chapter3_12'
 import XHTML155_PART04 from '@/components/xhtml1/55_Part04'
 import XHTML156_CHAPTER4_01 from '@/components/xhtml1/56_Chapter4_01'
 import XHTML157_CHAPTER4_02 from '@/components/xhtml1/57_Chapter4_02'
 import XHTML158_CHAPTER4_03 from '@/components/xhtml1/58_Chapter4_03'
 import XHTML159_CHAPTER4_04 from '@/components/xhtml1/59_Chapter4_04'
 import XHTML160_CHAPTER4_05 from '@/components/xhtml1/60_Chapter4_05'
 import XHTML161_CHAPTER4_06 from '@/components/xhtml1/61_Chapter4_06'
 import XHTML162_CHAPTER4_07 from '@/components/xhtml1/62_Chapter4_07'
 import XHTML163_CHAPTER4_08 from '@/components/xhtml1/63_Chapter4_08'
 import XHTML164_CHAPTER4_09 from '@/components/xhtml1/64_Chapter4_09'
 import XHTML165_CHAPTER4_10 from '@/components/xhtml1/65_Chapter4_10'
 import XHTML166_PART05 from '@/components/xhtml1/66_Part05'
 import XHTML167_CHAPTER5_01 from '@/components/xhtml1/67_Chapter5_01'
 import XHTML168_CHAPTER5_02 from '@/components/xhtml1/68_Chapter5_02'
 import XHTML169_CHAPTER5_03 from '@/components/xhtml1/69_Chapter5_03'
 import XHTML170_CHAPTER5_04 from '@/components/xhtml1/70_Chapter5_04'
 import XHTML171_CHAPTER5_05 from '@/components/xhtml1/71_Chapter5_05'
 import XHTML172_CHAPTER5_06 from '@/components/xhtml1/72_Chapter5_06'
 import XHTML173_CHAPTER5_07 from '@/components/xhtml1/73_Chapter5_07'
 import XHTML174_CHAPTER5_08 from '@/components/xhtml1/74_Chapter5_08'
 import XHTML175_CHAPTER5_09 from '@/components/xhtml1/75_Chapter5_09'
 import XHTML176_CHAPTER5_10 from '@/components/xhtml1/76_Chapter5_10'
 import XHTML177_CHAPTER5_11 from '@/components/xhtml1/77_Chapter5_11'
 import XHTML178_CHAPTER5_12 from '@/components/xhtml1/78_Chapter5_12'
 import XHTML179_CHAPTER5_13 from '@/components/xhtml1/79_Chapter5_13'
 import XHTML180_CHAPTER5_14 from '@/components/xhtml1/80_Chapter5_14'
 import XHTML181_CHAPTER5_15 from '@/components/xhtml1/81_Chapter5_15'
 import XHTML182_CHAPTER5_16 from '@/components/xhtml1/82_Chapter5_16'
 import XHTML183_CHAPTER5_17 from '@/components/xhtml1/83_Chapter5_17'
 import XHTML107_ACKNOWLEDGMENTS from '@/components/xhtml1/07_Acknowledgments'
 import XHTML200_COVER from '@/components/xhtml2/00_Cover'
 import XHTML201_TITLE from '@/components/xhtml2/01_Title'
 import XHTML202_PRAISE from '@/components/xhtml2/02_Praise'
 import XHTML204_DEDICATION from '@/components/xhtml2/04_Dedication'
 import XHTML205_FRONT2 from '@/components/xhtml2/05_Front2'
 import XHTML206_PROLOGUE from '@/components/xhtml2/06_Prologue'
 import XHTML207_PART1 from '@/components/xhtml2/07_Part1'
 import XHTML208_P1CH1 from '@/components/xhtml2/08_P1Ch1'
 import XHTML209_P1CH2 from '@/components/xhtml2/09_P1Ch2'
 import XHTML210_P1CH3 from '@/components/xhtml2/10_P1Ch3'
 import XHTML211_P1CH4 from '@/components/xhtml2/11_P1Ch4'
 import XHTML212_P1CH5 from '@/components/xhtml2/12_P1Ch5'
 import XHTML213_P1CH6 from '@/components/xhtml2/13_P1Ch6'
 import XHTML214_P1CH7 from '@/components/xhtml2/14_P1Ch7'
 import XHTML215_P1CH8 from '@/components/xhtml2/15_P1Ch8'
 import XHTML216_PART2 from '@/components/xhtml2/16_Part2'
 import XHTML217_PART3 from '@/components/xhtml2/17_Part3'
 import XHTML218_PART4 from '@/components/xhtml2/18_Part4'
 import XHTML219_PART5 from '@/components/xhtml2/19_Part5'
 import XHTML220_P5CH1 from '@/components/xhtml2/20_P5Ch1'
 import XHTML221_P5CH2 from '@/components/xhtml2/21_P5Ch2'
 import XHTML222_P5CH3 from '@/components/xhtml2/22_P5Ch3'
 import XHTML223_P5CH4 from '@/components/xhtml2/23_P5Ch4'
 import XHTML224_P5CH5 from '@/components/xhtml2/24_P5Ch5'
 import XHTML225_P5CH6 from '@/components/xhtml2/25_P5Ch6'
 import XHTML226_P5CH7 from '@/components/xhtml2/26_P5Ch7'
 import XHTML227_P5CH8 from '@/components/xhtml2/27_P5Ch8'
 import XHTML228_P5CH9 from '@/components/xhtml2/28_P5Ch9'
 import XHTML229_P5CH10 from '@/components/xhtml2/29_P5Ch10'
 import XHTML230_P5CH11 from '@/components/xhtml2/30_P5Ch11'
 import XHTML231_P5CH12 from '@/components/xhtml2/31_P5Ch12'
 import XHTML232_PART6 from '@/components/xhtml2/32_Part6'
 import XHTML233_PART7 from '@/components/xhtml2/33_Part7'
 import XHTML234_PART8 from '@/components/xhtml2/34_Part8'
 import XHTML235_PART9 from '@/components/xhtml2/35_Part9'
 import XHTML236_P9CH1 from '@/components/xhtml2/36_P9Ch1'
 import XHTML237_P9CH2 from '@/components/xhtml2/37_P9Ch2'
 import XHTML238_P9CH3 from '@/components/xhtml2/38_P9Ch3'
 import XHTML239_P9CH4 from '@/components/xhtml2/39_P9Ch4'
 import XHTML240_P9CH5 from '@/components/xhtml2/40_P9Ch5'
 import XHTML241_P9CH6 from '@/components/xhtml2/41_P9Ch6'
 import XHTML242_P9CH7 from '@/components/xhtml2/42_P9Ch7'
 import XHTML243_P9CH8 from '@/components/xhtml2/43_P9Ch8'
 import XHTML244_P9CH9 from '@/components/xhtml2/44_P9Ch9'
 import XHTML245_P9CH10 from '@/components/xhtml2/45_P9Ch10'
 import XHTML246_P9CH11 from '@/components/xhtml2/46_P9Ch11'
 import XHTML247_PART10 from '@/components/xhtml2/47_Part10'
 import XHTML248_PART11 from '@/components/xhtml2/48_Part11'
 import XHTML300_COVER from '@/components/xhtml3/00_Cover'
 import XHTML304_PRAISE from '@/components/xhtml3/04_Praise'
 import XHTML306_TITLE from '@/components/xhtml3/06_Title'
 import XHTML307_DED from '@/components/xhtml3/07_Ded'
 import XHTML308_FM01 from '@/components/xhtml3/08_Fm01'
 import XHTML309_FM02 from '@/components/xhtml3/09_Fm02'
 import XHTML310_PART01 from '@/components/xhtml3/10_Part01'
 import XHTML311_CHAPTER1_1 from '@/components/xhtml3/11_Chapter1_1'
 import XHTML312_CHAPTER1_2 from '@/components/xhtml3/12_Chapter1_2'
 import XHTML313_CHAPTER1_3 from '@/components/xhtml3/13_Chapter1_3'
 import XHTML314_CHAPTER1_4 from '@/components/xhtml3/14_Chapter1_4'
 import XHTML315_CHAPTER1_5 from '@/components/xhtml3/15_Chapter1_5'
 import XHTML316_CHAPTER1_6 from '@/components/xhtml3/16_Chapter1_6'
 import XHTML317_CHAPTER1_7 from '@/components/xhtml3/17_Chapter1_7'
 import XHTML318_CHAPTER1_8 from '@/components/xhtml3/18_Chapter1_8'
 import XHTML319_CHAPTER1_9 from '@/components/xhtml3/19_Chapter1_9'
 import XHTML320_CHAPTER1_10 from '@/components/xhtml3/20_Chapter1_10'
 import XHTML321_CHAPTER1_11 from '@/components/xhtml3/21_Chapter1_11'
 import XHTML322_CHAPTER1_12 from '@/components/xhtml3/22_Chapter1_12'
 import XHTML323_CHAPTER1_13 from '@/components/xhtml3/23_Chapter1_13'
 import XHTML324_CHAPTER1_14 from '@/components/xhtml3/24_Chapter1_14'
 import XHTML325_CHAPTER1_15 from '@/components/xhtml3/25_Chapter1_15'
 import XHTML326_PART02 from '@/components/xhtml3/26_Part02'
 import XHTML327_CHAPTER2_1 from '@/components/xhtml3/27_Chapter2_1'
 import XHTML328_CHAPTER2_2 from '@/components/xhtml3/28_Chapter2_2'
 import XHTML329_CHAPTER2_3 from '@/components/xhtml3/29_Chapter2_3'
 import XHTML330_CHAPTER2_4 from '@/components/xhtml3/30_Chapter2_4'
 import XHTML331_CHAPTER2_5 from '@/components/xhtml3/31_Chapter2_5'
 import XHTML332_CHAPTER2_6 from '@/components/xhtml3/32_Chapter2_6'
 import XHTML333_CHAPTER2_7 from '@/components/xhtml3/33_Chapter2_7'
 import XHTML334_CHAPTER2_8 from '@/components/xhtml3/34_Chapter2_8'
 import XHTML335_CHAPTER2_9 from '@/components/xhtml3/35_Chapter2_9'
 import XHTML336_CHAPTER2_10 from '@/components/xhtml3/36_Chapter2_10'
 import XHTML337_CHAPTER2_11 from '@/components/xhtml3/37_Chapter2_11'
 import XHTML338_PART03 from '@/components/xhtml3/38_Part03'
 import XHTML339_CHAPTER3_1 from '@/components/xhtml3/39_Chapter3_1'
 import XHTML340_CHAPTER3_2 from '@/components/xhtml3/40_Chapter3_2'
 import XHTML341_CHAPTER3_3 from '@/components/xhtml3/41_Chapter3_3'
 import XHTML342_CHAPTER3_4 from '@/components/xhtml3/42_Chapter3_4'
 import XHTML343_CHAPTER3_5 from '@/components/xhtml3/43_Chapter3_5'
 import XHTML344_CHAPTER3_6 from '@/components/xhtml3/44_Chapter3_6'
 import XHTML345_CHAPTER3_7 from '@/components/xhtml3/45_Chapter3_7'
 import XHTML346_CHAPTER3_8 from '@/components/xhtml3/46_Chapter3_8'
 import XHTML347_CHAPTER3_9 from '@/components/xhtml3/47_Chapter3_9'
 import XHTML348_PART04 from '@/components/xhtml3/48_Part04'
 import XHTML349_CHAPTER4_1 from '@/components/xhtml3/49_Chapter4_1'
 import XHTML350_CHAPTER4_2 from '@/components/xhtml3/50_Chapter4_2'
 import XHTML351_CHAPTER4_3 from '@/components/xhtml3/51_Chapter4_3'
 import XHTML352_CHAPTER4_4 from '@/components/xhtml3/52_Chapter4_4'
 import XHTML353_CHAPTER4_5 from '@/components/xhtml3/53_Chapter4_5'
 import XHTML354_CHAPTER4_6 from '@/components/xhtml3/54_Chapter4_6'
 import XHTML355_CHAPTER4_7 from '@/components/xhtml3/55_Chapter4_7'
 import XHTML356_CHAPTER4_8 from '@/components/xhtml3/56_Chapter4_8'
 import XHTML357_PART05 from '@/components/xhtml3/57_Part05'
 import XHTML358_CHAPTER5_1 from '@/components/xhtml3/58_Chapter5_1'
 import XHTML359_CHAPTER5_2 from '@/components/xhtml3/59_Chapter5_2'
 import XHTML360_CHAPTER5_3 from '@/components/xhtml3/60_Chapter5_3'
 import XHTML361_CHAPTER5_4 from '@/components/xhtml3/61_Chapter5_4'
 import XHTML362_CHAPTER5_5 from '@/components/xhtml3/62_Chapter5_5'
 import XHTML363_CHAPTER5_6 from '@/components/xhtml3/63_Chapter5_6'
 import XHTML364_CHAPTER5_7 from '@/components/xhtml3/64_Chapter5_7'
 import XHTML365_CHAPTER5_8 from '@/components/xhtml3/65_Chapter5_8'
 import LOVE_2 from '@/components/love_2'
 import XHTML185_AUTHOR from '@/components/xhtml1/85_Author'
 import XHTML186_COPYRIGHT from '@/components/xhtml1/86_Copyright'
 import XHTML1SERIESBACKAD from '@/components/xhtml1/seriesbackad'
 import XHTML187_ORIMAD from '@/components/xhtml1/87_ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/00_Cover",
 			"name" : "00_Cover",
 			"component" : A0_COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/portalist",
 			"name" : "portalist",
 			"component" : PORTALIST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/05_Title",
 			"name" : "05_Title",
 			"component" : A5_TITLE
 		},
 		{
 			"path" : "/xhtml1/00_Cover",
 			"name" : "xhtml1/00_Cover",
 			"component" : XHTML100_COVER
 		},
 		{
 			"path" : "/xhtml1/04_Praise",
 			"name" : "xhtml1/04_Praise",
 			"component" : XHTML104_PRAISE
 		},
 		{
 			"path" : "/xhtml1/05_Title",
 			"name" : "xhtml1/05_Title",
 			"component" : XHTML105_TITLE
 		},
 		{
 			"path" : "/xhtml1/06_Ded",
 			"name" : "xhtml1/06_Ded",
 			"component" : XHTML106_DED
 		},
 		{
 			"path" : "/xhtml1/09_Fm02",
 			"name" : "xhtml1/09_Fm02",
 			"component" : XHTML109_FM02
 		},
 		{
 			"path" : "/xhtml1/10_Part01",
 			"name" : "xhtml1/10_Part01",
 			"component" : XHTML110_PART01
 		},
 		{
 			"path" : "/xhtml1/11_Chapter1_01",
 			"name" : "xhtml1/11_Chapter1_01",
 			"component" : XHTML111_CHAPTER1_01
 		},
 		{
 			"path" : "/xhtml1/12_Chapter1_02",
 			"name" : "xhtml1/12_Chapter1_02",
 			"component" : XHTML112_CHAPTER1_02
 		},
 		{
 			"path" : "/xhtml1/13_Chapter1_03",
 			"name" : "xhtml1/13_Chapter1_03",
 			"component" : XHTML113_CHAPTER1_03
 		},
 		{
 			"path" : "/xhtml1/14_Chapter1_04",
 			"name" : "xhtml1/14_Chapter1_04",
 			"component" : XHTML114_CHAPTER1_04
 		},
 		{
 			"path" : "/xhtml1/15_Chapter1_05",
 			"name" : "xhtml1/15_Chapter1_05",
 			"component" : XHTML115_CHAPTER1_05
 		},
 		{
 			"path" : "/xhtml1/16_Chapter1_06",
 			"name" : "xhtml1/16_Chapter1_06",
 			"component" : XHTML116_CHAPTER1_06
 		},
 		{
 			"path" : "/xhtml1/17_Chapter1_07",
 			"name" : "xhtml1/17_Chapter1_07",
 			"component" : XHTML117_CHAPTER1_07
 		},
 		{
 			"path" : "/xhtml1/18_Chapter1_08",
 			"name" : "xhtml1/18_Chapter1_08",
 			"component" : XHTML118_CHAPTER1_08
 		},
 		{
 			"path" : "/xhtml1/19_Chapter1_09",
 			"name" : "xhtml1/19_Chapter1_09",
 			"component" : XHTML119_CHAPTER1_09
 		},
 		{
 			"path" : "/xhtml1/20_Chapter1_10",
 			"name" : "xhtml1/20_Chapter1_10",
 			"component" : XHTML120_CHAPTER1_10
 		},
 		{
 			"path" : "/xhtml1/21_Chapter1_11",
 			"name" : "xhtml1/21_Chapter1_11",
 			"component" : XHTML121_CHAPTER1_11
 		},
 		{
 			"path" : "/xhtml1/22_Chapter1_12",
 			"name" : "xhtml1/22_Chapter1_12",
 			"component" : XHTML122_CHAPTER1_12
 		},
 		{
 			"path" : "/xhtml1/23_Chapter1_13",
 			"name" : "xhtml1/23_Chapter1_13",
 			"component" : XHTML123_CHAPTER1_13
 		},
 		{
 			"path" : "/xhtml1/24_Chapter1_14",
 			"name" : "xhtml1/24_Chapter1_14",
 			"component" : XHTML124_CHAPTER1_14
 		},
 		{
 			"path" : "/xhtml1/25_Chapter1_15",
 			"name" : "xhtml1/25_Chapter1_15",
 			"component" : XHTML125_CHAPTER1_15
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js